import { saveSidebarPreference, sidebarStorageKeys } from '@srm/ui/shell/AppShell';
import { AppDispatch } from '@/store/index';
import { MainLayoutSlice } from '@/store/reducers/MainLayoutReducer';

export const MainLayoutActionCreators = {
    toggleMenu: (flag: boolean) => async (dispatch: AppDispatch) => {
        saveSidebarPreference(sidebarStorageKeys('').pinned, flag);
        dispatch(MainLayoutSlice.actions.toggleMenu(flag));
    },
};
